
import { InterceptMiddle } from '../../regular';
import _this from '@/main.js'
/**
 * 矩阵填空 获取单元格中最大值 并且拼接'{line}'列名 
 * MatrixD-value[Q1_6_1 = Max(5_1,5_2){line}]
 * @param item 目标单元格str
 * @param ques 当前试题
 * @param list 所有试题list
 */
export const MatrixDValue = (item, ques, list) => {
    // console.log(item, ques);
    // 比较 矩阵填空中数值的和 MatrixD-value[Q1_6_1 = Max(5_1,5_2){line}]
    if (item.indexOf('=') == -1) return
    let str = item.replace(/\s/g,'').split('=')
    // 目标 试题编号
    let code = InterceptMiddle(str[0], ['MatrixD-value['], ['_']) // 试题编号
    if (code != ques.quesCode) return
    let row = InterceptMiddle(str[0], ['_'], ['_']) // 行号
    let option = InterceptMiddle(str[0], [`_${row}_`], []) // 选项号
    let result = getValue(InterceptMiddle(str[1], [], [']']), ques.questionsSonList)
    let value = result.value
    let tip = result.tip
    ques.tip = tip
    Voluation(value, ques.questionsSonList,row, option)
    return ques
}

const getValue = (str, SonList) => {
    // console.log('str :>> ', str);
    if(str.indexOf('D-value(') == -1) return
    let allCodeArr = InterceptMiddle(str, ['D-value('], [')']).split(',')
    let maxObj = {
        val: 0,
        line: ''
    }
    allCodeArr.forEach((ele) => {
        let row = InterceptMiddle(ele, [], ['_']) // 行号
        let option = InterceptMiddle(ele, [`${row}_`], []) // 选项号
        SonList.forEach((val) => {
            if (val.orderNum == row){
                val.optionList.forEach((info) => {
                    if (info.orderNum == option) {
                        if (info.userAnswer > maxObj.val) {
                            maxObj.line = info.labelName.replace(/<[^>]+>|&[^>]+;/g, '')
                        }
                        maxObj.val = Math.abs(info.userAnswer - maxObj.val)
                    }
                })
            }
        })
    })
    let result = ''
    if (str.indexOf('{line}') != -1) {
        if (maxObj.val > 0 && maxObj.val < 4) {
            result += `${_this.$t('UserAnswer.ExplanationScores')} ${_this.$t('UserAnswer.ExplanationScoresA')} ${maxObj.val} ,${_this.$t('UserAnswer.ExplanationScoresB')} ${maxObj.line} ${_this.$t('UserAnswer.ExplanationScoresC')}`
        } else if (maxObj.val > 4 && maxObj.val < 8){
            result += `${_this.$t('UserAnswer.ExplanationScores')} ${_this.$t('UserAnswer.ExplanationScoresA')} ${maxObj.val} ,${_this.$t('UserAnswer.ExplanationScoresD')} ${maxObj.line} ${_this.$t('UserAnswer.ExplanationScoresE')}`
        } else if (maxObj.val > 8 && maxObj.val < 12){
            result += `${_this.$t('UserAnswer.ExplanationScores')} ${_this.$t('UserAnswer.ExplanationScoresA')} ${maxObj.val} ,${_this.$t('UserAnswer.ExplanationScoresF')} ${maxObj.line} ${_this.$t('UserAnswer.ExplanationScoresG')}`
        }
    }
    
    return {
        value: str.indexOf('{line}') != -1 ? maxObj.val + maxObj.line : maxObj.val,
        tip: result
    }
}

/**
 * 赋值
 * @param {String} value
 * @param {Object} ques 
 */
export const Voluation = (value, SonList, row, option) => {
    SonList = SonList.map((val) =>{
        if (val.orderNum == row
            && (val.type == '1' || val.type == '2')
        ) {
            val.optionList = val.optionList.map((info) => {
                if (info.orderNum == option) {
                    info.userAnswer = value
                }
                return info
            })
        }
        return val
    })
}